"use strict";
document.addEventListener("DOMContentLoaded", () => {
    articlesSummary();
});

const articlesSummary = () => {
    const summaries = document.querySelectorAll('.articles-summary');
    summaries.forEach(summaryWrapper => {
        const filters   = summaryWrapper.querySelectorAll('.filters input[name="category"]');
        const summary   = summaryWrapper.querySelector('.summary');
        const moreWrap  = summaryWrapper.querySelector('.more');
        const moreBtn   = moreWrap ? moreWrap.querySelector('.btn--more') : null;

        let currentCategory = false;

        filters.forEach(input => {
            input.addEventListener('change', () => {
                scriptObj.crrpage = 1;
                currentCategory = input.value;

                const formData = new FormData();
                formData.append('action', 'load_more_action');
                formData.append('_wpnonce', scriptObj.nonce);
                formData.append('category', currentCategory);
                formData.append('type', summary.dataset.type);
                formData.append('perPage', summary.dataset.perpage);
                formData.append('pp', scriptObj.crrpage);
                formData.append('lang', scriptObj.lang);


                fetch(scriptObj.ajaxurl, { method: 'POST', body: formData })
                    .then(res => res.json())
                    .then(data => {
                        summary.innerHTML = data.data;
                        if (data.max > scriptObj.crrpage) {
                            moreWrap.classList.remove('hidden');
                        } else {
                            moreWrap.classList.add('hidden');
                        }
                    });
            });
        });

        const defaultChecked = summaryWrapper.querySelector('input[name="category"]:checked');
        if (defaultChecked) {
            currentCategory = defaultChecked.value;
            defaultChecked.click();
        }
        const urlHash = window.location.hash.replace('#', '');
        if (urlHash) {
            const hashInput = summaryWrapper.querySelector(`input[name="category"][data-hash="${urlHash}"]`);
            if (hashInput) {
                hashInput.click();
                setTimeout(() => {
                    const rect = summaryWrapper.getBoundingClientRect();
                    const offset = window.scrollY + rect.top - 120;
                    window.scrollTo({ top: offset, behavior: 'smooth' });
                }, 200);
            }
        }

        if (moreBtn) {
            moreBtn.addEventListener('click', e => {
                e.preventDefault();
                scriptObj.crrpage++;

                const formData = new FormData();
                formData.append('action', 'load_more_action');
                formData.append('_wpnonce', scriptObj.nonce);
                formData.append('category', currentCategory);
                formData.append('type', summary.dataset.type);
                formData.append('perPage', summary.dataset.perpage);
                formData.append('pp', scriptObj.crrpage);
                formData.append('lang', scriptObj.lang);

                fetch(scriptObj.ajaxurl, { method: 'POST', body: formData })
                    .then(res => res.json())
                    .then(data => {
                        summary.insertAdjacentHTML('beforeend', data.data);
                        if (data.max > scriptObj.crrpage) {
                            moreWrap.classList.remove('hidden');
                        } else {
                            moreWrap.classList.add('hidden');
                        }
                    });
            });
        }
    });
};
